import {constInitialStateRequest} from "../../../constants";

const initialState = {
    sidebar: constInitialStateRequest()
};

export const settingReducer = function (state = initialState, action) {
    switch (action.type) {

    }
    return state;
};